import { accessToken } from "../../shared/constants/localstorage.constant";
import { clearActiveTeamId } from "../active-team/active-team";

let isClearingAuthSession = false;

export const isAuthSessionBeingCleared = (): boolean => isClearingAuthSession;

export const clearAuthSession = (): void => {
  if (isClearingAuthSession) {
    return;
  }

  isClearingAuthSession = true;
  try {
    localStorage.removeItem(accessToken);
    clearActiveTeamId();
  } finally {
    isClearingAuthSession = false;
  }
};

export const syncActiveTeamWithAuthToken = (): void => {
  if (!localStorage.getItem(accessToken)) {
    clearActiveTeamId();
  }
};
